import WebinarList from '../section/webinarpage/WebinarList';
import WebinarHistory from '../section/webinarpage/WebinarHistory';

export default function WebinarPage() {
  return (
    <div className="bg-[#F8F9FE] h-full overflow-hidden flex flex-col">
       <WebinarList />
       <WebinarHistory />
    </div>
  );
}